import React, { useEffect, useState } from "react";
import { NblocksButton } from "../../shared/NblocksButton";
import { useTranslation } from "react-i18next";
const FederationConnectionsComponent = ({
  connections,
  didClickConnection
}) => {
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState("");
  const clickMiddleWare = connection => {
    setLoading(connection.id);
    didClickConnection(connection);
  };
  useEffect(() => {
    if (connections && connections.length === 1) {
      // Auto submit if only one connection available
      clickMiddleWare(connections[0]);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, connections.map((connection, i) => /*#__PURE__*/React.createElement(NblocksButton, {
    size: "sm",
    type: "tertiary",
    fullWidth: true,
    onClick: () => clickMiddleWare(connection),
    isLoading: loading === connection.id,
    key: `conn-${i}`
  }, t("Sign in with") + " " + connection.name)));
};
export { FederationConnectionsComponent };